import React from 'react';
import { useDispatch, useSelector } from 'react-redux'

import InstantQuote from 'pu-react/components/InstantQuoteFC';
import Quantities from 'pu-react/components/Quantities';
import NumberLayer from 'pu-react/components/NumberLayer';
import BoardSize from 'pu-react/components/BoardSize';
import MaterialType from 'pu-react/components/MaterialType';
import MaterialThickness from 'pu-react/components/MaterialThickness';
import FinishPlating from 'pu-react/components/FinishPlating';
import CopperWeight from 'pu-react/components/CopperWeight';
import Soldermask from 'pu-react/components/Soldermask';
import Silkscreen from 'pu-react/components/Silkscreen';

import SectionPanelized from 'pu-react/components/SectionPanelized';
import SectionAdvancedSpecs from 'pu-react/components/SectionAdvancedSpecs';

import GoldFingers from 'pu-react/components/GoldFingers';
import GoldThickness from 'pu-react/components/GoldThickness';
import Pitch from 'pu-react/components/Pitch';
import MinTraceSpace from 'pu-react/components/MinTraceSpace';
import BlindBuriedHole from 'pu-react/components/BlindBuriedHole';
import SmallestHoleSize from 'pu-react/components/SmallestHoleSize';

import PlatedSlots from 'pu-react/components/PlatedSlots';
import Counterbore from 'pu-react/components/Counterbore';
import BlindSlot from 'pu-react/components/BlindSlot';
import PlatedEdges from 'pu-react/components/PlatedEdges';
import Countersink from 'pu-react/components/Countersink';
import ControlledDielectric from 'pu-react/components/ControlledDielectric';
import ControlledImpedance from 'pu-react/components/ControlledImpedance';

import SpecialInstruction from 'pu-react/components/SpecialInstruction';
import RequiredInformation from 'pu-react/components/RequiredInformation';

import SupplierSelected from 'pu-react/components/SupplierSelected';
import ProductQuoteNumber from 'pu-react/components/ProductQuoteNumber';
import ParametersChanged from 'pu-react/components/ParametersChanged';
import RowSelected from 'pu-react/components/RowSelected';
import ColumnSelected from 'pu-react/components/ColumnSelected';
import VendorSelected from 'pu-react/components/VendorSelected';

import {
  changeParameter,
  doQuote,
  updateValidatorFlag,
  validator,
} from '../fabricationSlice';

import { isParameterNameQtyValid } from 'pu-utils/validate';
import { changeGlobalParameter } from 'product_tabs/actions';

export default () => {
  const dispatch = useDispatch();
  const {
    parameters,
  } = useSelector((state) => state.fabrication)

  const onChangeParameter = (name, value) => {
    dispatch(changeParameter({ name, value }))
    if (isParameterNameQtyValid(name)) dispatch(changeGlobalParameter({ name: `fabrication_${name}`, value }));
  }

  const onQuoteRequest = () => {
    if (validator.allValid()) {
      validator.showMessages();
      dispatch(doQuote());
    } else {
      validator.showMessages();
      dispatch(updateValidatorFlag());
    }
  }

  const props = {
    parameters,
    onChangeParameter,
  }

  // useEffect(() => {
  //   const { onChangeParameter } = props;
  //   if (Spree.quick_quote) {
  //     _.each(Spree.quick_quote, (value, key) => {
  //       onChangeParameter(key, value);
  //     });

  //     setTimeout(() => {
  //       jQuery('form .instant-quote-top .btn-main-action').click();
  //     }, 500);
  //   }
  // }, [])

  return (
    <div className="pcb-form-section">
      <div className="row">

        <div className="col-md-6">
          <span className="standard-specs-title">Standard Specs</span>
        </div>
        <div className="col-md-6 instant-quote-top">
          <InstantQuote {...props} onQuoteRequest={onQuoteRequest} />
        </div>

        <div className="col-md-12">
          <Quantities
            {...props}
            errorMessage={validator.message('Quantity', parameters.quantities, 'group_required|group_numeric|group_min:1,num')} />
        </div>
        <div className="col-6 col-lg-12 col-xl-6">
          <NumberLayer {...props} />
        </div>
        <div className="col-6 col-lg-12 col-xl-6">
          <BoardSize
            {...props}
            errorMessageLength={validator.message('Board Length', parameters.board_length, 'required|numeric|min:0.1,num|max:20,num')}
            errorMessageWidth={validator.message('Board Width', parameters.board_width, 'required|numeric|min:0.1,num|max:33,num')} />
        </div>
        <div className="col-md-12">
          <div id="error_board_size" />
        </div>

        <div className="col-md-12">
          <SectionPanelized {...props} />
        </div>

        <div className="col-md-12">
          <MaterialType {...props} />
        </div>
        <div className="col-md-12">
          <MaterialThickness {...props} />
        </div>
        <div className="col-md-12">
          <FinishPlating {...props} />
        </div>
        <div className="col-md-12">
          <CopperWeight {...props} />
        </div>
        <div className="col-md-12">
          <Soldermask {...props} />
        </div>
        <div className="col-md-12">
          <Silkscreen {...props} />
        </div>

        <div className="col-md-12">
          <SectionAdvancedSpecs {...props} >
            <div className="row">
              <div className="col-md-6">
                <GoldFingers {...props} />
              </div>
              <div className="col-md-6">
                <GoldThickness {...props} />
              </div>
              <div className="col-md-6">
                <Pitch {...props} />
              </div>
              <div className="col-md-6">
                <MinTraceSpace {...props} />
              </div>
              <div className="col-md-6">
                <BlindBuriedHole {...props} />
              </div>
              <div className="col-md-6">
                <SmallestHoleSize {...props} />
              </div>
              <div className="col-md-12">
                <PlatedSlots {...props} />
                <Counterbore {...props} />
                <BlindSlot {...props} />
                <PlatedEdges {...props} />
                <Countersink {...props} />
                <ControlledDielectric {...props} />
                <ControlledImpedance {...props} />
              </div>
            </div>
          </SectionAdvancedSpecs>
        </div>

        <div className="col-md-12">
          <SpecialInstruction {...props} />
        </div>

        <div>
          <SupplierSelected {...props} />
          <ProductQuoteNumber {...props} />
          <ParametersChanged {...props} />
          <RowSelected {...props} />
          <ColumnSelected {...props} />
          <VendorSelected {...props} />
          <input type="hidden" name="quantity" value="1" />
        </div>
      </div>

      <div className="row">
        <div className="col-md-12">
          <RequiredInformation />
        </div>
      </div>
    </div>
  );
};
